import _store from '@/plugins/store.plugin';

export const store = _store;
export default store;
